import IProductConfigurationItem from 'api/interfaces/products/IProductConfigurationItem';
import translations from 'services/translations/translations';

import { NAME } from 'services/products/productConfigurationAttributeTypes';

import {
  PRODUCT,
  PRODUCT_SELECT,
  SELECT,
  SELECT_OPTION,
} from 'services/products/productConfigurationItemTypes';

const getAddItemTitle = (
  item: IProductConfigurationItem | null,
  t: any
): string => {
  if (item === null) {
    return '';
  }

  const nameAttribute =
    item === null
      ? undefined
      : item.attributes.find((attribute) => attribute.type === NAME);

  const parentName =
    nameAttribute === undefined ? '' : `${nameAttribute.value}: `;

  if (item.type === PRODUCT) {
    return `${parentName}${t(
      `${translations.productConfigurations}:Add product`
    )}`;
  }

  if (item.type === PRODUCT_SELECT) {
    return t(`${translations.productConfigurations}:Add product select`);
  }

  if (item.type === SELECT) {
    return t(`${translations.productConfigurations}:Add select`);
  }

  if (item.type === SELECT_OPTION) {
    return `${parentName}${t(
      `${translations.productConfigurations}:Add option`
    )}`;
  }

  return '';
};

export default getAddItemTitle;
